import React from 'react';
import { useTranslation } from 'react-i18next';
import DetailItem from './DetailItem';
import OriginalSize from './OriginalSize';
import { deviationHasFileSizeMetadata } from './helpers';
import defaultStyles from './Default.scss';
export const DetailItemList = ({ deviation })=>{
    var _deviation_extended, _deviation;
    const { t } = useTranslation();
    var _deviation_extended_exif;
    const exif = (_deviation_extended_exif = (_deviation = deviation) === null || _deviation === void 0 ? void 0 : (_deviation_extended = _deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.exif) !== null && _deviation_extended_exif !== void 0 ? _deviation_extended_exif : [];
    const hasDetails = exif.length > 0 || deviationHasFileSizeMetadata(deviation);
    if (!hasDetails) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: defaultStyles['detail-group-title']
    }, t('deviation.details.camera')), /*#__PURE__*/ React.createElement(OriginalSize, {
        deviation: deviation
    }), exif.map(({ tag, value })=>/*#__PURE__*/ React.createElement(DetailItem, {
            key: tag,
            name: tag,
            value: value,
            transPrefix: "exif."
        })));
};
DetailItemList.displayName = 'DetailItemList';
export default DetailItemList;
